import { render, staticRenderFns } from "./GramPv.vue?vue&type=template&id=025c6f16"
import script from "./GramPv.vue?vue&type=script&lang=ts"
export * from "./GramPv.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports